import React from "react"
import { Button, Form, FormField } from "@/components/ui-primitives/small"
import { ToolName } from "@/components/StandaloneToolPage"

export function PlatformTools(props: { repoURL: string; localRepoURL?: string }) {
  return (
    <Form>
      <FormField>
        <Button variant="outline" onClick={() => openToolWindow("rule-editor", props.repoURL, props.localRepoURL)}>
          Rule Editor
        </Button>
        <Button variant="outline" onClick={() => openToolWindow("ontology-editor", props.repoURL, props.localRepoURL)}>
          Ontology Editor
        </Button>
        <Button variant="outline" onClick={() => openToolWindow("ontology-viewer", props.repoURL, props.localRepoURL)}>
          Ontology Viewer
        </Button>
        <Button variant="outline" onClick={() => openToolWindow("ld-editor", props.repoURL, props.localRepoURL)}>
          Linked Data Editor
        </Button>
        <Button variant="outline" onClick={() => openToolWindow("workbench", props.repoURL, props.localRepoURL)}>
          Workbench
        </Button>
      </FormField>
    </Form>
  )
}

function openToolWindow(toolName: ToolName, repoURL: string, localRepoURL?: string) {
  const params = new URLSearchParams({ repo: repoURL })
  if (localRepoURL) params.set("localRepo", localRepoURL)
  window.open(`/tools/${toolName}?${params}`, `tool-${toolName}`, "width=1200,height=800")
}
